module.exports = __webpack_public_path__ + "img/Logo_final_blanco.1c505008.png";